import React from 'react'

// Types
import { ModalState } from '../types'

export const initialState: ModalState = {
  content: null,
  actions: {
    openModal: () => {},
    closeModal: () => {},
  },
}

const ModalContext = React.createContext(initialState)

export default ModalContext
